import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Pagination from "@mui/material/Pagination";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import DeliveryModesData from "../../components/datatables/deliveryModes/DeliveryModesData";
import { fetchDeliveryModes } from "../../feature/deliveryModes/deliveryModesSlice";

const DeliveryModes = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDeliveryModes());
    window.scrollTo({ top: "0", behavior: "smooth" });
  }, [dispatch]);

  return (
    <Box component={Paper} minHeight={"600px"} elevation={0}>
      <Box px={3} py={2}>
        <Typography variant='h4'>Delivery Modes</Typography>
      </Box>
      <Divider />
      <Box px={3} my={3}>
        <DeliveryModesData />
      </Box>
      <Box width={"50%"} mx='auto' my={3} p={3}>
        <Pagination count={10} showFirstButton showLastButton shape='rounded' />
      </Box>
    </Box>
  );
};
export default DeliveryModes;
